export { focusFirstErrorField, useFocusOnError } from "./focusManagement"
export { generateSchema } from "./FormSchema"
export { getAlternateMetadataFromPathname } from "./getAlternateMeta"
export {
  getAccordionItems,
  type AccordionItem,
  type ContactUsInnerItem,
} from "./getContactContent"
export { getLocalizedUrl } from "./getLocalizedUrl"
export { getNonUmbracoUrl } from "./getNonUmbracoUrl"
export {
  applicationContactClick,
  applicationRequestClick,
  applicationRequestError,
  applicationRequestSuccess,
  busPaymentReportError,
  busPaymentReportStep,
  busPaymentReportSuccess,
  contactUsClick,
  footerMenuClick,
  infoClick,
  infoMenuClick,
  jobInfoClick,
  menuContactClick,
  methodsPaymentPublicTransport,
  pageStripFaq,
  ravKavLocateStations,
  ravKavTypes,
  searchResultClick,
  searchSubmit,
  sendCvClick,
  sendCvError,
  sendCvSuccess,
  subInfoClick,
  webMenuClick,
} from "./gtm"
export {
  cleanHtmlForMeta,
  decodeHtmlEntities,
  stripHtmlTags,
} from "./htmlUtils"
export { cultureMap, getDirection, type Culture } from "./intl"
export {
  baseIframeUrl,
  customerId,
  widgetLocaleConfig,
} from "./moovitConstants"

export { Link, redirect, routing, usePathname, useRouter } from "./routing"

export { extractProperty } from "./extractProperty"

export { getUmbracoPublicUrl, getUmbracoServerUrl } from "./getUmbracoUrl"

/** Search result shape returned by /app-api/search */
export type Result = Array<{
  name: string
  type: string
  title: string
  url: string
}>
export { replaceRichTextLinks } from "./replaceRichTextLinks"

export { formatTrafficDescription } from "./formatTrafficDescription"

export { sanitizeAnchorId } from "./htmlUtils"
